<!-- resources/js/views/Reset.vue -->
<template>
    <div class="p-4 text-center text-gray-700">
        Réinitialisation en cours…
    </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

onMounted(() => {
    // ❶ Vide uniquement la clé unlockedStep (si tu veux conserver d'autres clés, sinon clear())
    localStorage.clear()

    // ❷ Redirige vers l’accueil (home) dès que possible
    router.replace('/')
})
</script>

<style scoped>
/* tu peux ajouter un spinner ici si tu veux */
</style>
